"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../../node_modules/bootstrap/dist/js/bootstrap.min.js");
require("./carousel");
var coockies_1 = require("./coockies");
var menu_1 = require("./menu");
var parallax_1 = __importDefault(require("./parallax"));
var progressiveImages_1 = __importDefault(require("./progressiveImages"));
require("./pswp");
require("./smoothscroll");
menu_1.toggleMenu();
parallax_1.default();
progressiveImages_1.default();
menu_1.fixheader();
coockies_1.drupalCookie();
